import * as React from 'react';
import {
    Table,
    ButtonToolbar,
    ButtonGroup,
    Button,
    FormControl,
    Checkbox,
    FormGroup,
    ControlLabel,
    Collapse,
    Row,
    Col
} from 'react-bootstrap';
import { merge } from 'lodash';
import * as Site from '../../../shared/Site';
import { Translate } from '../../../shared/LanguageService';
import { assign } from '../../../shared/Assign';
import FormSelect from '../../../components/common/FormSelect';
import LogsModal from '../../logs/LogsModal';
import FormValidationService from '../../../shared/form/FormValidationService';
import {getSiteName} from "../../../shared/Site";

const notVisible = {
    id: 1,
    name: 'broker-tree-product-allocation-type/not-visible'
};
const visible = { id: 2, name: 'broker-tree-product-allocation-type/visible' };
const preChosen = {
    id: 3,
    name: 'broker-tree-product-allocation-type/pre-chosen'
};

const brokerTreeProductAllocationTypes = (): { id: number; name: string }[] => [
    notVisible,
    visible,
    preChosen
];

const notVisibleAllocationType: string = '1';
const defaultAllocationTypeId_Visible = 2;

const RequierdType: string = '2';
const defaultRequiredTypeId_NotRequired = 1;

type Site = {
    id: number;
    name: string;
};

export type Product = {
    allocationType: number;
    allocationTypeName: string;
    id: number;
    isFromProduct: boolean;
    name: string;
    overrideName: string;
    priceBrokerFirm: number;
    pricePropertyOwner: number;
    required: number;
    requiredName: string;
    site: number;
    type: number;
    userSite: Site;
};

export type ProductOverride = {
    allocationType?: number;
    allocationTypeName?: string;
    id?: number;
    isFromProduct?: boolean;
    name?: string;
    overrideName?: string;
    priceBrokerFirm?: number;
    pricePropertyOwner?: number;
    required?: number;
    requiredName?: string;
    site?: number;
    type?: number;
    userSite?: Site;
};

export function calculatePricePropertyOwnerPlaceholder(
    selectedProduct: Product | null,
    selectedProductOverride: ProductOverride | null
): string | number {
    if (selectedProductOverride && selectedProductOverride.pricePropertyOwner) {
        return selectedProductOverride.pricePropertyOwner;
    }

    if (!selectedProduct) {
        return '';
    }

    if (selectedProduct.pricePropertyOwner) {
        return selectedProduct.pricePropertyOwner;
    }

    return '';
}

class ProductList extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            selectedProductType: undefined,
            selectedProduct: undefined,

            selectedProductOverride: {},
            availableProducts: [],
            errors: {},

            open: false,
            showOnlyVisible: true,
            showLogs: false
        };

        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
        this.onProductTypeChange = this.onProductTypeChange.bind(this);
        this.onProductChange = this.onProductChange.bind(this);
        this.onAllocationTypeChange = this.onAllocationTypeChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.updateAvailableProducts(null, nextProps.availableProducts, nextProps.products);
    }

    viewLogs(e: any, item: any) {
        e.stopPropagation();
        this.setState({ showLogs: true, showLogsForId: item.productId });
    }

    remove(e: any, item: any) {
        e.stopPropagation();
        let products = assign([], this.props.products);
        let index = products.findIndex(
            (x: any) => x.productId.toString() === item.productId.toString()
        );
        let product = assign({}, item);

        products.splice(index, 1);

        if (product.overridden) {
            products.splice(index, 0, product.overridden);
        }

        this.props.update(products);
    }

    add() {
        const newProduct: any = merge(
            {},
            this.state.selectedProduct,
            this.state.selectedProductOverride
        );
        const originalProduct: any = assign({}, this.state.selectedProduct);

        newProduct.productId = originalProduct.id;
        newProduct.productTypeName = this.props.availableProductTypes.find(
            (x: any) => x.id.toString() === this.state.selectedProductType.toString()
        ).name;
        newProduct.productName = originalProduct.name;

        if (this.getProductValue('allocationType', -1)) {
            newProduct.allocationTypeName = brokerTreeProductAllocationTypes().find(
                (x: any) => x.id.toString() === newProduct.allocationType.toString()
            ).name;
        }

        if (newProduct.required) {
            newProduct.requiredName = this.props.brokerTreeProductAllocationRequiredOptions.find(
                (x: any) => x.id.toString() === newProduct.required.toString()
            ).name;
        }

        newProduct.overridden = {
            isFromProduct: this.state.selectedProduct.id,
            productId: this.state.selectedProduct.id,
            productTypeName: originalProduct.productTypeName,
            productName: originalProduct.productName,
            site: originalProduct.site,
            name: originalProduct.name,
            priceBrokerFirm: originalProduct.priceBrokerFirm,
            pricePropertyOwner: originalProduct.pricePropertyOwner,
            type: originalProduct.type,
            allocationType: originalProduct.allocationType,
            required: this.getProductValue('required', ''),
            allocationTypeName: brokerTreeProductAllocationTypes().find(
                (m) => m.id === originalProduct.allocationType
            ).name,
            requiredName: this.props.brokerTreeProductAllocationRequiredOptions.find(
                (m) => (m.id = originalProduct.required)
            ).displayName
        };

        newProduct.isVisible = newProduct.allocationType === 2;

        const products: any = assign([], this.props.products);
        products.push(newProduct);

        this.props.update(products);

        this.setState({
            selectedProduct: undefined,
            selectedProductOverride: undefined
        });
    }

    getAvailableProducts = (list?: any[], productType?: any, products?: any) => {
        if (this.state.selectedProductType) {
            list = list ? list : this.props.availableProducts;
            productType = productType ? productType : this.state.selectedProductType;
            products = products ? products : this.props.products;

            return list
                .filter((x: any) => x.type.toString() === productType.toString())
                .filter(
                    (x: any) =>
                        !products.find((y: any) => {
                            return !y.isFromParent && x.id.toString() === y.productId.toString();
                        })
                );
        }
    };

    onProductTypeChange(e: any) {
        this.setState({ selectedProductType: e.target.value }, () => {
            this.updateAvailableProducts(this.state.selectedProductType);
        });
    }

    onProductChange(e: any) {
        const productId: number = e.target.value;

        if (productId) {
            const product = this.props.availableProducts.find(
                (x: any) => x.id.toString() === productId.toString()
            );
            let selectedProduct = {};

            if (product) {
                selectedProduct = product;
            }

            this.setState({
                selectedProduct,
                selectedProductOverride: {
                    allocationType: defaultAllocationTypeId_Visible,
                    required: defaultRequiredTypeId_NotRequired
                }
            });
        }
    }

    onAllocationTypeChange(e: any) {
        this.setOverrideProductValue('allocationType', e.target.value);
    }

    updateAvailableProducts(
        productType?: any,
        availableProductsFromProps?: any[],
        productsFromProps?: any
    ) {
        let availableProducts = this.getAvailableProducts(
            availableProductsFromProps,
            productType,
            productsFromProps
        );
        this.setState({ availableProducts: availableProducts });
    }

    toggleProduct(product: any) {
        product.open = product.open ? false : true;
        this.props.update(this.props.products);
    }

    isAddButtonDisabled(): boolean {
        return !this.state.selectedProductType || !this.state.selectedProduct;
    }

    isControlsDisabled = () =>
        this.state.selectedProductType === undefined || this.state.selectedProduct === undefined;

    getProductValue = (propertyName: string, defaultValue: any, hideBase: boolean = false) => {
        if (
            this.state.selectedProductOverride &&
            this.state.selectedProductOverride[propertyName]
        ) {
            return this.state.selectedProductOverride[propertyName];
        } else if (
            this.state.selectedProduct &&
            this.state.selectedProduct[propertyName] &&
            !hideBase
        ) {
            return this.state.selectedProduct[propertyName];
        } else {
            return defaultValue;
        }
    };

    setOverrideProductValue = (propertyName: string, value: any, callback?: () => void) => {
        let productOverride: any = { ...this.state.selectedProductOverride };
        productOverride[propertyName] = value;

        this.setState(
            {
                selectedProductOverride: productOverride
            },
            callback
        );
    };

    getPricePropertyOwnerPlaceholder = () => {
        const { selectedProductOverride, selectedProduct } = this.state;

        const product: Product | null = selectedProduct ? selectedProduct : null;
        const productOverride: ProductOverride | null = selectedProductOverride
            ? selectedProductOverride
            : null;

        return calculatePricePropertyOwnerPlaceholder(product, productOverride);
    };

    render() {
        return (
            <fieldset>
                <fieldset>
                    <legend>{Translate('broker/product/form/title')}</legend>
                    <Row>
                        <Col sm={6}>
                            <FormGroup className="required">
                                <ControlLabel>
                                    {Translate('broker/product/form/product-type')}
                                </ControlLabel>
                                <FormSelect
                                    name="productType"
                                    value={
                                        this.state.selectedProductType
                                            ? this.state.selectedProductType
                                            : ''
                                    }
                                    onChange={this.onProductTypeChange}
                                    defaultTranslateKey="broker/product/form/product-type-default-option"
                                >
                                    {this.props.availableProductTypes.map((x: any) => (
                                        <option value={x.id} key={x.id}>
                                            {x.name}
                                        </option>
                                    ))}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup className="required">
                                <ControlLabel>
                                    {Translate('broker/product/form/product')}
                                </ControlLabel>
                                <FormSelect
                                    name="productId"
                                    disabled={this.state.selectedProductType === undefined}
                                    value={
                                        this.state.selectedProduct
                                            ? this.state.selectedProduct.productId
                                            : -1
                                    }
                                    onChange={this.onProductChange}
                                    defaultTranslateKey="broker/product/form/product-default-option"
                                >
                                    {this.state.availableProducts &&
                                        this.state.availableProducts.map(
                                            (x: any, index: number) => {
                                                return (
                                                        <option value={x.id} key={x.id + '_' + index}>
                                                            {x.name} ({x.userSite.name})
                                                        </option>
                                                );
                                            }
                                        )}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('broker/product/form/override-type')}
                                </ControlLabel>
                                <FormSelect
                                    name="allocationType"
                                    disabled={this.isControlsDisabled()}
                                    value={this.getProductValue(
                                        'allocationType',
                                        defaultAllocationTypeId_Visible
                                    )}
                                    onChange={this.onAllocationTypeChange}
                                    defaultTranslateKey="broker/product/form/override-type-default-option"
                                    defaultOptionValue={0}
                                >
                                    {brokerTreeProductAllocationTypes().map(
                                        (brokerTreeProductAllocationType: any, index: number) => (
                                            <option
                                                value={brokerTreeProductAllocationType.id}
                                                key={
                                                    brokerTreeProductAllocationType.id + '_' + index
                                                }
                                            >
                                                {Translate(brokerTreeProductAllocationType.name)}
                                            </option>
                                        )
                                    )}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('broker/product/form/required')}
                                </ControlLabel>
                                <FormSelect
                                    name="required"
                                    disabled={this.isControlsDisabled()}
                                    value={this.getProductValue(
                                        'required',
                                        defaultRequiredTypeId_NotRequired
                                    )}
                                    onChange={(e: any) => {
                                        this.setOverrideProductValue('required', e.target.value);
                                    }}
                                    defaultTranslateKey="broker/product/form/override-required-default-option"
                                >
                                    {this.props.brokerTreeProductAllocationRequiredOptions.map(
                                        (x: any) => (
                                            <option value={x.id} key={x.id}>
                                                {Translate(x.name)}
                                            </option>
                                        )
                                    )}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <ControlLabel>{Translate('broker/product/form/name')}</ControlLabel>
                                <FormControl
                                    type="text"
                                    name="name"
                                    disabled={this.isControlsDisabled()}
                                    placeholder={this.getProductValue('name', '')}
                                    value={this.getProductValue('name', '', true)}
                                    onChange={(e: any) => {
                                        this.setOverrideProductValue('name', e.target.value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('broker/product/form/price-broker-firm')}
                                </ControlLabel>
                                <FormControl
                                    type="number"
                                    name="priceBrokerFirm"
                                    disabled={this.isControlsDisabled()}
                                    placeholder={this.getProductValue('priceBrokerFirm', '')}
                                    value={this.getProductValue('priceBrokerFirm', '', true)}
                                    onChange={(e: any) => {
                                        this.setOverrideProductValue(
                                            'priceBrokerFirm',
                                            e.target.value
                                        );
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('broker/product/form/price-property-owner')}
                                </ControlLabel>
                                <FormControl
                                    type="number"
                                    name="pricePropertyOwner"
                                    disabled={this.isControlsDisabled()}
                                    placeholder={this.getPricePropertyOwnerPlaceholder().toString()}
                                    value={this.getProductValue('pricePropertyOwner', '', true)}
                                    onChange={(e: any) => {
                                        this.setOverrideProductValue(
                                            'pricePropertyOwner',
                                            e.target.value
                                        );
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <Checkbox
                                name="only-visible"
                                checked={this.state.showOnlyVisible}
                                onChange={() =>
                                    this.setState({
                                        showOnlyVisible: !this.state.showOnlyVisible
                                    })
                                }
                            >
                                <span>{Translate('broker-tree/product/only-visible')}</span>
                            </Checkbox>
                        </Col>
                        <Col sm={6}>
                            <Button
                                className="pull-right"
                                bsSize="small"
                                bsStyle="success"
                                disabled={this.isAddButtonDisabled()}
                                onClick={this.add}
                            >
                                {Translate('broker/product/form/add-button')}{' '}
                                <i className="material-icons">add</i>
                            </Button>
                        </Col>
                    </Row>

                    <Table hover responsive className="product-override-table">
                        <thead>
                            <tr>
                                <th>{Translate('broker/product/table/header/product-type')}</th>
                                <th>{Translate('broker/product/table/header/product')}</th>
                                <th>{Translate('broker/product/table/header/name')}</th>
                                <th>
                                    {Translate('broker/product/table/header/price-broker-firm')}
                                </th>
                                <th>
                                    {Translate('broker/product/table/header/price-property-owner')}
                                </th>
                                <th>{Translate('broker/product/table/header/override-type')}</th>
                                <th>{Translate('broker/product/table/header/required')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        {this.props.products
                            .filter((x: any) => x.isFromParent)
                            .filter((x: any) =>
                                this.state.showOnlyVisible
                                    ? x.isVisible || x.allocationType === 3
                                    : true
                            )
                            .map((x: any, index: number) => {
                                return (
                                    <tbody key={'fromproduct_' + x.productId + '_' + index}>
                                        <tr className={Site.getOrderCssClass(x.site)}>
                                            <td>{x.productTypeName}</td>
                                            <td>{x.productName}</td>
                                            <td>{x.name}</td>
                                            <td>{x.priceBrokerFirm}</td>
                                            <td>{x.pricePropertyOwner}</td>
                                            <td>{Translate(x.allocationTypeName)}</td>
                                            <td>{Translate(x.requiredName)}</td>
                                            <td className="tools">
                                                <ButtonToolbar>
                                                    <ButtonGroup>
                                                        {this.props.showProductLogs && (
                                                            <Button
                                                                bsStyle="info"
                                                                bsSize="small"
                                                                onClick={(e: any) =>
                                                                    this.viewLogs(e, x)
                                                                }
                                                            >
                                                                <i className="material-icons">
                                                                    list
                                                                </i>
                                                            </Button>
                                                        )}
                                                    </ButtonGroup>
                                                </ButtonToolbar>
                                            </td>
                                        </tr>
                                    </tbody>
                                );
                            })}
                        {this.props.products
                            .filter((x: any) => !x.isFromParent)
                            .filter((x: any) =>
                                this.state.showOnlyVisible
                                    ? x.isVisible || x.allocationType === 3
                                    : true
                            )
                            .map((x: any, index: number) => {
                                if (!x.overridden) {
                                    return undefined;
                                }
                                return (
                                    <tbody key={x.productId + '_' + index}>
                                        <tr
                                            className={
                                                'product-override ' +
                                                Site.getOrderCssClass(x.overridden.site)
                                            }
                                            onClick={() => x.overridden && this.toggleProduct(x)}
                                        >
                                            <td>
                                                {x.overridden && (
                                                    <i className="material-icons">
                                                        {x.open === true
                                                            ? 'keyboard_arrow_down'
                                                            : 'keyboard_arrow_right'}
                                                    </i>
                                                )}
                                                {x.productTypeName}
                                            </td>
                                            <td>{x.productName}</td>
                                            <td
                                                className={
                                                    x.name
                                                        ? 'product-override'
                                                        : 'product-overridden'
                                                }
                                            >
                                                {x.name || x.overridden.name}
                                            </td>
                                            <td
                                                className={
                                                    x.priceBrokerFirm
                                                        ? 'product-override'
                                                        : 'product-overridden'
                                                }
                                            >
                                                {x.priceBrokerFirm !== null
                                                    ? x.priceBrokerFirm
                                                    : x.overridden.priceBrokerFirm}
                                            </td>
                                            <td
                                                className={
                                                    x.pricePropertyOwner
                                                        ? 'product-override'
                                                        : 'product-overridden'
                                                }
                                            >
                                                {x.pricePropertyOwner !== null
                                                    ? x.pricePropertyOwner
                                                    : x.overridden.pricePropertyOwner}
                                            </td>
                                            <td
                                                className={
                                                    x.allocationTypeName
                                                        ? 'product-override'
                                                        : 'product-overridden'
                                                }
                                            >
                                                {Translate(
                                                    x.allocationTypeName ||
                                                        x.overridden.allocationTypeName
                                                )}
                                            </td>
                                            <td
                                                className={
                                                    x.requiredName
                                                        ? 'product-override'
                                                        : 'product-overridden'
                                                }
                                            >
                                                {Translate(
                                                    x.requiredName || x.overridden.requiredName
                                                )}
                                            </td>
                                            <td className="tools">
                                                <ButtonToolbar>
                                                    <ButtonGroup>
                                                        {this.props.showProductLogs && (
                                                            <Button
                                                                bsStyle="info"
                                                                bsSize="small"
                                                                onClick={(e: any) =>
                                                                    this.viewLogs(e, x)
                                                                }
                                                            >
                                                                <i className="material-icons">
                                                                    list
                                                                </i>
                                                            </Button>
                                                        )}
                                                        <Button
                                                            bsStyle="danger"
                                                            bsSize="small"
                                                            onClick={(e: any) => this.remove(e, x)}
                                                        >
                                                            <i className="material-icons">
                                                                delete_forever
                                                            </i>
                                                        </Button>
                                                    </ButtonGroup>
                                                </ButtonToolbar>
                                            </td>
                                        </tr>
                                        {x.overridden && (
                                            <Collapse in={x.open} timeout={0}>
                                                <tr
                                                    key={'overridden_' + x.productId}
                                                    className={
                                                        'product-overridden ' +
                                                        Site.getOrderCssClass(x.overridden.site)
                                                    }
                                                >
                                                    <td></td>
                                                    <td></td>
                                                    <td>{x.overridden.name}</td>
                                                    <td>{x.overridden.priceBrokerFirm}</td>
                                                    <td>{x.overridden.pricePropertyOwner}</td>
                                                    <td>
                                                        {Translate(x.overridden.allocationTypeName)}
                                                    </td>
                                                    <td>{Translate(x.overridden.requiredName)}</td>
                                                    <td></td>
                                                </tr>
                                            </Collapse>
                                        )}
                                    </tbody>
                                );
                            })}
                    </Table>

                    {this.state.showLogs && (
                        <LogsModal
                            id={this.state.showLogsForId}
                            type="ProductId"
                            shouldShowModal={this.state.showLogs}
                            closeModal={() => this.setState({ showLogs: false, showLogsForId: 0 })}
                        />
                    )}
                </fieldset>
                {FormValidationService.isEdit(this.props.isEdit) ? (
                    <fieldset>
                        <legend>{Translate('broker/product/form/title-visualize-price')}</legend>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Checkbox
                                        key="showPrice"
                                        style={{ marginTop: '-10px' }}
                                        name="showPrice"
                                        checked={this.props.showPrice}
                                        onChange={this.props.onChange}
                                    >
                                        <span>{Translate('broker/product/form/show-price')}</span>
                                    </Checkbox>
                                </FormGroup>
                            </Col>
                        </Row>
                    </fieldset>
                ) : null}
            </fieldset>
        );
    }
}

export default ProductList;
